<div class="panel widget pilot">
    <div class="panel-heading-flex">
        <div class="panel-icon">
            <img imgPath="/icons/icon-personnel.png" />
        </div>
        <div class="panel-title">Personnel</div>

        <div class="panel-content" style="flex-grow: 1">
            <label>Status: </label>
            <ng-select
                [items]="selectedPersonnelListOptions"
                [(ngModel)]="selectedPersonnelList"
                (ngModelChange)="changeStatus()"
                bindLabel="name"
                [clearable]="false"
                appendTo="#dashboard"
            >
                <ng-template ng-optgroup-tmp let-item="item">
                    {{ item.name }}
                </ng-template>
                <ng-template
                    ng-option-tmp
                    ng-label-tmp
                    let-item="item"
                    let-index="index"
                ><span class="ng-option-label">
                        {{ item.name }}
                    </span>
                </ng-template>
            </ng-select>
        </div>

        <div class="panel-buttons" style="flex: 0.7">
            <ng-container
                *ngIf="
                    licences != null && licences
                        | guardType
                            : isCurrentSubscription as currentSubscription
                "
            >
                <a
                    *ngIf="
                        canViewBilling &&
                        canAddPersonnel &&
                        currentSubscription.totalPersonnel != null
                    "
                    (click)="showOrganisationSubscriptionSettings()"
                    angularticsAction="personnel-widget-licences"
                    angularticsCategory="subscriptions"
                ><span class="display-label">Licences </span>
                    {{ currentSubscription.assignedPersonnel }} /
                    {{ currentSubscription.totalPersonnel }}</a
                >
            </ng-container>

            <button
                *ngIf="canViewBilling && licences?.type === 'no_subscriptions'"
                type="button"
                class="btn btn-golden"
                (click)="showOrganisationSubscriptionSettings()"
                angulartics2On="click"
                angularticsAction="personnel-widget-upgrade"
                angularticsCategory="subscriptions"
            >
                Upgrade to add personnel
            </button>
            <button
                class="btn btn-inline"
                (click)="showPersonnelReportsDialogue()"
                tooltip="Personnel reports"
                placement="left"
                angulartics2On="click"
                angularticsAction="dashboard-personnel-reports"
            >
                <span class="fa-print fa"></span>
            </button>
            <button
                *ngIf="canAddPersonnel"
                class="btn btn-inline"
                (click)="newPerson()"
                [disabled]="!licences?.hasLicencesAvailable"
                tooltip="Add or invite someone to your organisation"
                placement="left"
                angulartics2On="click"
                angularticsAction="dashboard-personnel-add"
            >
                <span class="fa-plus fa"></span>
            </button>
        </div>
    </div>
    <div class="panel-body">
        <static-table
            *ngIf="(view$ | async) === 'CURRENT'"
            [availableColumns]="availableColumns"
            [selectedColumns]="selectedColumns"
            [tableData]="tablePersonnel"
            [tableConfig]="tableConfig"
            [columnSorting]="columnSorting"
            [tableSearch]="tableSearch"
            (pageChanged)="onTablePageChanged($event)"
            (selectedColumnsChanged)="updateSelectedColumns($event.selectedColumns)"
            (itemLimitUpdated)="updateItemLimit($event)"
            (sortOrderChanged)="updateColumnSorting($event)"
            (search)="updateSearchPreferences($event)"
            [centeredHeadings]="true"
            [borderless]="true"
            data-cy="personnelListTable"
        >
        </static-table>

        <!-- Historical Personnel-->
        <static-table
            *ngIf="(view$ | async) === 'HISTORICAL'"
            [availableColumns]="availableColumns"
            [selectedColumns]="selectedColumns"
            [tableData]="tablePersonnel"
            [tableConfig]="historicalTableConfig"
            [columnSorting]="columnSorting"
            [tableSearch]="tableSearch"
            (selectedColumnsChanged)="updateSelectedColumns($event.selectedColumns)"
            (itemLimitUpdated)="updateItemLimitForHistorical($event)"
            (sortOrderChanged)="updateColumnSorting($event)"
            (search)="updateSearchPreferences($event)"
            [centeredHeadings]="true"
            [borderless]="true"
            data-cy="personnelListTable"
        >
        </static-table>

        <!-- Invited Personnel-->
        <static-table
            *ngIf="(view$ | async) === 'INVITED'"
            [availableColumns]="availableColumns"
            [selectedColumns]="inviteColumns"
            [tableData]="tablePersonnel"
            [tableConfig]="inviteTableConfig"
            [columnSorting]="columnSorting"
            [tableSearch]="tableSearch"
            (selectedColumnsChanged)="updateSelectedColumns($event.selectedColumns)"
            (itemLimitUpdated)="updateItemLimitForInvites($event)"
            (sortOrderChanged)="updateColumnSorting($event)"
            (search)="updateSearchPreferences($event)"
            [centeredHeadings]="true"
            [borderless]="true"
            data-cy="personnelListTable"
        >
        </static-table>
        <loading-indicator [isLoading]="working"></loading-indicator>
    </div>
</div>
